// bootstrap Tabs
import 'bootstrap/js/dist/tab'
import ResponsiveTabs from '../libs/ResponsiveTabs/js/ResponsiveTabs'

// Styles
import '../libs/ResponsiveTabs/css/ResponsiveTabs'
import '../../scss/components/respTabs'

const tabs = document.querySelectorAll('.respTabs')
tabs.forEach(el => {
  const navTabs = el.querySelector('.nav-tabs')
  if (navTabs.querySelectorAll('li.nav-item').length > 1) {
    const tabs = new ResponsiveTabs(navTabs)
    tabs.init()
  }
})
